"use client";

import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';
import { getNoteType, getContentTypeLabel } from '@/lib/utils/noteTypeHelpers';

interface PromoScoreDisplayProps {
  upvotes?: number;
  downvotes?: number;
  categoryName?: string | null;
}

const PromoScoreDisplay: React.FC<PromoScoreDisplayProps> = ({
  upvotes = 0,
  downvotes = 0,
  categoryName,
}) => {
  const score = upvotes - downvotes;
  const isPositive = score >= 0;
  const noteType = getNoteType(categoryName);
  const contentLabel = getContentTypeLabel(noteType, true);

  return (
    <div className="flex items-center gap-3">
      {/* Upvotes */}
      <div className="flex items-center gap-1.5">
        <ArrowUp className="h-4 w-4 text-green-600 dark:text-green-400" />
        <span className="text-sm font-semibold text-green-600 dark:text-green-400">{upvotes}</span>
      </div>

      {/* Downvotes */}
      <div className="flex items-center gap-1.5">
        <ArrowDown className="h-4 w-4 text-red-600 dark:text-red-400" />
        <span className="text-sm font-semibold text-red-600 dark:text-red-400">{downvotes}</span>
      </div>

      {/* Score separator */}
      <div className="w-px h-5 bg-border" />

      {/* Total Score */}
      <span className={`text-sm font-bold ${isPositive ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'}`}>
        {isPositive ? '+' : ''}{score}
      </span>
    </div>
  );
};

export default PromoScoreDisplay;
